import styles from './Utilization.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

export interface UtilizationArrayDetail {
  imgSrc: string
  title: string
  text: string
}

export interface UtilizationItem {
  sectionTitle: string
  sectionRead: string
  utilizationArray: UtilizationArrayDetail[]
}

interface Props {
  UtilizationEach: UtilizationItem[]
}

const Utilization: React.FC<Props> = ({ UtilizationEach }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.utilization} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>{UtilizationEach[0].sectionTitle}</h2>
      <p className={styles.sectionRead}>{UtilizationEach[0].sectionRead}</p>
      <div className={styles.wrapper}>
        {UtilizationEach[0].utilizationArray.map((item, idx) => (
          <section className={styles.utilizationItem} key={idx}>
            <div className={styles.utilizationItem__cts}>
              <figure className={styles.utilizationItem__cts__image}>
                <img src={item.imgSrc} alt={item.title} width={48} height={48} />
              </figure>
              <h3 className={styles.utilizationItem__cts__title}>{item.title}</h3>
            </div>
            <p className={styles.utilizationItem__text}>{item.text}</p>
          </section>
        ))}
      </div>
    </section>
  )
}

export default Utilization
